module.exports = __webpack_public_path__ + "img/save.4a0580c2.svg";